import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Plus, Pencil, Trash2, X, Save, Navigation, Eye, EyeOff, ChevronDown } from 'lucide-react';

const NavManager = () => {
  const { api } = useAuth();
  const [navs, setNavs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ label: '', order: 0, visible: true, link_type: 'all', link_category: '', children_text: '' });

  const load = () => {
    api.get('/admin/nav').then(r => setNavs(r.data || [])).catch(console.error);
    api.get('/admin/categories').then(r => setCategories(r.data || [])).catch(console.error);
  };
  useEffect(() => { load(); }, []);

  const resetForm = () => { setForm({ label: '', order: 0, visible: true, link_type: 'all', link_category: '', children_text: '' }); setEditing(null); setShowForm(false); };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...form };
      // Parse children from text
      if (payload.children_text && payload.children_text.trim()) {
        payload.children = payload.children_text.split("\n").filter(l => l.trim()).map(l => {
          const [label, cat] = l.split("|").map(s => s.trim());
          return { label: label || cat, link_category: cat || label };
        });
      } else {
        payload.children = null;
      }
      delete payload.children_text;
      delete payload._id;
      if (editing) { await api.put(`/admin/nav/${editing}`, payload); }
      else { await api.post('/admin/nav', payload); }
      resetForm(); load();
    } catch (err) { alert(err.response?.data?.detail || 'Error'); }
  };

  const handleEdit = (n) => {
    const children_text = (n.children || []).map(c => `${c.label}|${c.link_category}`).join("\n");
    setForm({
      label: n.label, order: n.order || 0, visible: n.visible !== false,
      link_type: n.link_type || 'all', link_category: n.link_category || '',
      children_text
    });
    setEditing(n.id); setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this nav item?')) return;
    await api.delete(`/admin/nav/${id}`); load();
  };

  const toggleVisible = async (n) => {
    const { _id, ...data } = n;
    await api.put(`/admin/nav/${n.id}`, { ...data, visible: !n.visible });
    load();
  };

  const linkTypes = [
    { value: 'all', label: 'All Videos (Home)' },
    { value: 'category', label: 'Filter by Category' },
    { value: 'terbaru', label: 'Bokep Terbaru (newest)' },
    { value: 'trending', label: 'Trending (most viewed)' },
    { value: 'cerita', label: 'Cerita Dewasa' },
    { value: 'categories-dropdown', label: 'Categories Dropdown (auto semua category)' },
  ];

  const getLinkLabel = (n) => {
    if (n.link_type === 'category') return `Category: ${n.link_category}`;
    const lt = linkTypes.find(l => l.value === n.link_type);
    return lt ? lt.label : n.link_type || 'All Videos';
  };

  return (
    <div className="admin-section">
      <div className="section-header">
        <h2 className="section-title"><Navigation size={20} /> Navigation Menu ({navs.length})</h2>
        <button className="btn-primary" onClick={() => { resetForm(); setShowForm(true); }}><Plus size={16} /> Add Menu</button>
      </div>

      <div className="admin-card" style={{ marginBottom: 16, padding: 14, background: 'rgba(255,60,60,0.04)', borderColor: 'rgba(255,60,60,0.1)' }}>
        <p style={{ fontSize: 12, color: '#888', margin: 0 }}>
          Menu di sini otomatis muncul di navigation bar website. Pilih "Link Type" untuk menentukan halaman tujuan setiap menu.
          <br/><strong style={{color:'#ff3c3c'}}>Dropdown:</strong> Isi "Sub-menu Items" untuk buat dropdown di website (mobile & desktop). Kosongkan jika tidak perlu dropdown.
        </p>
      </div>

      {showForm && (
        <div className="admin-card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 className="card-subtitle" style={{ margin: 0 }}>{editing ? 'Edit Menu' : 'Add Menu'}</h3>
            <button className="btn-sm btn-delete" onClick={resetForm}><X size={14} /></button>
          </div>
          <form onSubmit={handleSave}>
            <div className="two-col">
              <div>
                <label className="form-label">Label *</label>
                <input className="form-input" value={form.label} onChange={e => setForm({...form, label: e.target.value})} required placeholder="e.g. Bokep Jepang" />
              </div>
              <div>
                <label className="form-label">Sort Order</label>
                <input className="form-input" type="number" value={form.order} onChange={e => setForm({...form, order: parseInt(e.target.value) || 0})} />
              </div>
            </div>

            <div className="two-col" style={{ marginTop: 12 }}>
              <div>
                <label className="form-label">Link Type *</label>
                <select className="form-select" value={form.link_type} onChange={e => setForm({...form, link_type: e.target.value})}>
                  {linkTypes.map(lt => <option key={lt.value} value={lt.value}>{lt.label}</option>)}
                </select>
              </div>
              {form.link_type === 'category' && (
                <div>
                  <label className="form-label">Select Category</label>
                  <select className="form-select" value={form.link_category} onChange={e => setForm({...form, link_category: e.target.value})}>
                    <option value="">-- Select --</option>
                    {categories.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
                  </select>
                </div>
              )}
              <div>
                <div className="toggle-wrap" style={{ marginTop: 20 }}>
                  <button type="button" className={`toggle-switch ${form.visible ? 'active' : ''}`} onClick={() => setForm({...form, visible: !form.visible})} />
                  <span className="toggle-label">Visible on website</span>
                </div>
              </div>
            </div>

            {/* Dropdown Sub-items */}
            <div style={{ marginTop: 16, padding: 16, background: 'rgba(255,60,60,0.03)', borderRadius: 10, border: '1px solid rgba(255,60,60,0.08)' }}>
              <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <ChevronDown size={14} /> Sub-menu / Dropdown Items <span style={{ fontSize: 10, color: '#555', fontWeight: 400 }}>(opsional)</span>
              </label>
              <textarea className="form-textarea" rows={5} value={form.children_text}
                onChange={e => setForm({...form, children_text: e.target.value})}
                placeholder={"Kosongkan jika tidak perlu dropdown.\n\nContoh isi:\nBokep Jepang|Japan\nBokep Korea|Korea\nBokep Barat|Western\nBokep Indo|Indonesia"} 
                style={{ fontFamily: 'monospace', fontSize: 12 }} />
              <div style={{ fontSize: 10, color: '#666', marginTop: 4, lineHeight: 1.6 }}>
                <strong>Format:</strong> Label|Category — satu item per baris<br/>
                <strong>Contoh:</strong> <code style={{ color: '#ff3c3c' }}>Bokep Jepang|Japan</code> → menu "Bokep Jepang" filter category "Japan"<br/>
                <strong>Kosongkan</strong> = menu biasa tanpa dropdown
              </div>
            </div>

            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button type="submit" className="btn-primary"><Save size={16} /> {editing ? 'Update' : 'Add Menu'}</button>
              <button type="button" className="btn-secondary" onClick={resetForm}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div className="admin-card" style={{ padding: 0, overflow: 'hidden' }}>
        <table className="admin-table">
          <thead>
            <tr><th>#</th><th>Label</th><th>Link Type</th><th>Dropdown</th><th>Status</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {navs.map(n => (
              <tr key={n.id}>
                <td style={{ color: '#555' }}>{n.order}</td>
                <td style={{ fontWeight: 700, color: '#fff' }}>{n.label}</td>
                <td><span className="badge badge-info">{getLinkLabel(n)}</span></td>
                <td>
                  {n.children && n.children.length > 0 ? (
                    <span className="badge badge-warning" style={{ fontSize: 10 }}>
                      ▾ {n.children.length} items
                    </span>
                  ) : (
                    <span style={{ fontSize: 10, color: '#555' }}>—</span>
                  )}
                </td>
                <td>
                  <button className={`badge ${n.visible !== false ? 'badge-success' : 'badge-danger'}`} 
                    onClick={() => toggleVisible(n)} style={{ cursor: 'pointer', border: 'none' }}>
                    {n.visible !== false ? <><Eye size={10} /> Visible</> : <><EyeOff size={10} /> Hidden</>}
                  </button>
                </td>
                <td>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <button className="btn-sm btn-edit" onClick={() => handleEdit(n)}><Pencil size={12} /></button>
                    <button className="btn-sm btn-delete" onClick={() => handleDelete(n.id)}><Trash2 size={12} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NavManager;
